// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalGraph_root__3JJ_M","empty":"ModalGraph_empty__GVlDs"};